import { Dayjs } from "dayjs"
import {
  PaymentReviewRecordStatus,
  IPaymentReviewRecord,
  PaymentReviewFailureErrorCode,
  PaymentReviewFailureReason,
} from "./paymentReviewRecord.types"
import { FAILURE_REASONS_MAPPED } from "@/constants/paymentReview"

export class PaymentReviewRecord implements IPaymentReviewRecord {
  constructor(
    public id: number,
    public accountNumber: string,
    public status: PaymentReviewRecordStatus,
    public createdAt: Dayjs,
    public failureErrorCode?: PaymentReviewFailureErrorCode,
    public nextPaymentDate?: Dayjs,
    public paymentSchedulePeriodAmount?: number,
    public newMonthlyAmount?: number,
    public changedAmount?: number,
    public changePercentage?: number,
    public accountBalance?: number,
    public estimateAnnualCost?: number,
    public lastRetryTime?: Dayjs,
  ) {}

  get failureReasonMapped(): PaymentReviewFailureReason | undefined {
    if (!this.failureErrorCode) return undefined
    return (
      FAILURE_REASONS_MAPPED[this.failureErrorCode] ?? {
        text: this.failureErrorCode,
        type: "danger",
      }
    )
  }
}
